import { memo } from "react"
import { placeholderImage } from "../../Assets/images"
import "./style.css"

const ProfileDisplay = props => {

    const { name, email, image, className = "" } = props

    return (
        <div className="d-flex align-items-center">
            {
                image &&
                <div>
                    <img
                        src={
                            image
                                ? `${process.env.REACT_APP_IMAGE_ENDPOINT}${image}`
                                : placeholderImage
                        }
                        alt="thumbnail"
                        className={"thumbnail " + className}
                    />
                </div>
            }
            <div>
                <p className="m-0 text-capitalize">{`${name}`}</p>
                {
                    email &&
                    <p className="m-0 font-sm font-sec">
                        {`${email}`}
                    </p>
                }
            </div>
        </div>
    )
}

export default memo(ProfileDisplay)